export default "__VITE_ASSET__DB_eq5cm__"